"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useAnalytics } from "@/lib/analytics";
import type { CustomerIOProvider } from "@/lib/analytics/providers/customer-io-provider";

/**
 * Customer.io in-app page rules need page() calls on SPA route changes.
 * Keep this centralized so client-side navigation stays message-aware.
 */
export function CustomerIOPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { getAnalyticsManager } = useAnalytics();
  const search = searchParams.toString();

  useEffect(() => {
    const manager = getAnalyticsManager();

    void manager
      .initialize()
      .then(() => manager.getProvider<CustomerIOProvider>("customerio")?.page())
      .catch((error) => {
        console.error("[Customer.io] Failed to track page change", error);
      });
  }, [getAnalyticsManager, pathname, search]);

  return null;
}
